module.exports = __webpack_public_path__ + "img/plus-square.46ec6c72.svg";